import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { Button, Result } from 'antd';
import { StaffRole } from '@mygate/common';
import { useAuthStore } from '@/stores/authStore';

export function AdminRoute() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const role = useAuthStore(state => state.staff?.role);

  // Check if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if not admin. Say so instead of redirecting silently: a shared or bookmarked admin link that
  // lands on the dashboard without a word looks like a broken link.
  if (role !== StaffRole.ADMIN) {
    return (
      <Result
        status="403"
        title="Kein Zugriff"
        subTitle="Dieser Bereich ist nur für Administratoren freigegeben."
        extra={
          <Button type="primary" onClick={() => navigate('/dashboard', { replace: true })}>
            Zum Dashboard
          </Button>
        }
      />
    );
  }

  // User is authenticated and is an admin
  return <Outlet />;
}
